import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { Col, IconSmile, Row, SectionWrapper } from '../../../../brenger-shared-ui';

export const Loading: React.FC = () => {
  return (
    <SectionWrapper sectionStyle={'white'} extraClasses={'profile-dashboard-wrapper'} centerContent={true}>
      <Row>
        <Col xs={8} md={8} extraClasses={'offset-2 pb-[1em]'}>
          <div className="flex items-center gap-2 h-[80vh]">
            <IconSmile spinning={true} /> <Translate id={'request_flow.thank_you.verifying_payment'} />
          </div>
        </Col>
      </Row>
    </SectionWrapper>
  );
};
